import SearchInput from "core/components/SearchInput"
import DashboardLayout from "core/layouts/DashboardLayout"
import React from "react"
import MentorDashboardTable from "./components/MentorDashboardTable"
import useMentorDashboardViewModel from "./MentorDashboardViewModel"
import { Button } from "core/components/v2/Button"
import Toast from "core/components/Toast"
import Loader from "core/components/Loader"
import GoalSettingMentorModal from "./components/GoalSettingMentorModal"
import { CrossIcon } from "core/constants/svgs"
import Select from "core/components/new/Select"

export default function MentorDashboardView() {
  const {
    mentorData,
    searchByEmail,
    searchByCourse,
    getMentorsData,
    handleSearchByEmail,
    handleSearchByCourse,
    searchingforEmail,
    searchingByCourse,
    handleInstructor,
    handleDisableMentor,
    toggleGoalSettingMentor,
    handleLockMentor,
    toast,
    changeToastVisibility,
    downloadMentorsCSV,
    loading,
    isGoalSettingMentorModal,
    setIsGoalSettingMentorModal,
    mentorList,
    newMilestoneSessionMentor,
    setNewMilestoneSessionMentor,
    fetchMentorsList,
    updateGoalSettingMentorHandler,
    fetchGoalSettingMentorStudents,
    goalSettingMentorStudents,
    selectedMentors,
    handleMentorChange,
    clearNewGoalSettingMentorHandler,
    setMentorId,
    mentorId,
    refreshData,
    studentListLoading,
  } = useMentorDashboardViewModel()

  const tableHeaders = [
    "",
    "General Info",
    "No. of Mentees",
    "Bandwidth",
    "Current Company",
    "Experience",
    "Instructor",
    "Disable",
    "Lock Mentor",
    "Goal Setting Mentor",
    "Edit",
  ]

  React.useEffect(() => {
    getMentorsData()
  }, [refreshData])
  React.useEffect(() => {
    fetchMentorsList()
  }, [refreshData])
  return (
    <DashboardLayout>
      <div className="mt-[40px] mb-8 flex flex-row items-center">
        <SearchInput
          className="ml-[24px] h-[40px] w-[292px] rounded-[8px]"
          placeholder="Search by Email !"
          value={searchByEmail}
          onChange={handleSearchByEmail}
        />
        {/* <SearchInput
          className="ml-[24px] h-[40px] w-[292px] rounded-[8px]"
          placeholder="Search by course !"
          value={searchByCourse}
          onChange={handleSearchByCourse}
        /> */}
        <select
          name=""
          id=""
          onChange={handleSearchByCourse}
          value={searchByCourse}
          className="ml-[24px] h-[40px] w-[292px] rounded-[8px]"
        >
          <option value="">Select Course</option>
          <option value="Both">Both</option>
          <option value="DSML">DSML</option>
          <option value="Evolve">Evolve</option>
          <option value="SDE">SDE</option>
        </select>
        <div className="px-12 py-4">
          <Button className="w-[300px] h-[60px]" onClick={() => downloadMentorsCSV(mentorData)}>
            {loading ? <Loader /> : "Download all mentors data"}
          </Button>
        </div>
      </div>

      {isGoalSettingMentorModal && (
        <GoalSettingMentorModal open={true}>
          <div className="px-[24px] py-[24px]">
            <div className=" flex justify-end items-center my-[13px]">
              <button
                className=" cursor-pointer"
                onClick={() => {
                  setIsGoalSettingMentorModal(false)
                  clearNewGoalSettingMentorHandler()
                }}
              >
                <CrossIcon />
              </button>
            </div>

            {studentListLoading && (
              <div>
                <Loader />
              </div>
            )}
            {goalSettingMentorStudents.map((student: any, index: any) => {
              return (
                <div key={index} className="my-[13px] flex  justify-between items-center">
                  <p className=" mx-2 w-[150px] text-ellipsis whitespace-nowrap px-2 overflow-hidden">
                    {student?.student_id}
                  </p>

                  <Select
                    required
                    className="w-[170px] mt-[2px] rounded-[4px] h-[33px]"
                    defaultOption="Select New Goal Setting Mentor"
                    options={mentorList}
                    value={selectedMentors[student?.student_id] || ""}
                    onChange={(e: any) => handleMentorChange(student.student_id, e.target.value)}
                  />
                </div>
              )
            })}

            {!studentListLoading && (
              <div className=" flex w-full justify-center items-center h-[50px] bg-white  sticky bottom-0">
                <Button
                  onClick={() => {
                    toggleGoalSettingMentor(mentorId)
                    updateGoalSettingMentorHandler()
                  }}
                >
                  Change Goal Setting mentor
                </Button>
              </div>
            )}
          </div>
        </GoalSettingMentorModal>
      )}

      <MentorDashboardTable
        updateGoalSettingMentorHandler={updateGoalSettingMentorHandler}
        tableHeaders={tableHeaders}
        goalSettingMentorStudents={goalSettingMentorStudents}
        fetchGoalSettingMentorStudents={fetchGoalSettingMentorStudents}
        isGoalSettingMentorModal={isGoalSettingMentorModal}
        setIsGoalSettingMentorModal={setIsGoalSettingMentorModal}
        newMilestoneSessionMentor={newMilestoneSessionMentor}
        setNewMilestoneSessionMentor={setNewMilestoneSessionMentor}
        mentorData={mentorData}
        mentorList={mentorList}
        selectedMentors={selectedMentors}
        handleMentorChange={handleMentorChange}
        searchByEmail={searchByEmail}
        searchByCourse={searchByCourse}
        searchingforEmail={searchingforEmail}
        searchingByCourse={searchingByCourse}
        handleInstructor={handleInstructor}
        setMentorId={setMentorId}
        handleDisableMentor={handleDisableMentor}
        handleDisableGoalSettingMentor={toggleGoalSettingMentor}
        handleLockMentor={handleLockMentor}
      />
      <Toast data={toast} onClick={() => changeToastVisibility(false)} />
    </DashboardLayout>
  )
}
